module.exports = __webpack_public_path__ + "img/index-section7-award1.4d832c2f.png";